import 'slick-carousel';
const TABLET_WIDTH = 1024
const MOBILE_WIDTH = 768

const $slides = $('.js-slider-timeline .js-slider-timeline-slides');
const $thumbs = $('.js-slider-timeline .js-slider-timeline-dots');
let time = 3;
let isPause,
    tick,
    percentTime;
const $bar = $thumbs.find('span')
let timeout

$slides.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplaySpeed: time * 1000,
  asNavFor: $thumbs,
  autoplay: false,
  dots: false,
  infinite: true
});

$thumbs.slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  asNavFor: $slides,
  dots: false,
  arrows: false,
  focusOnSelect: true,
  autoplay: false,
  infinite: true,
  responsive: [
    {
      breakpoint: MOBILE_WIDTH,
      settings: {
        slidesToShow: 3
      }
    }
  ]
});

$slides.on('beforeChange', function(event, slick, currentSlide, nextSlide){
  startProgressbar();
});

const startProgressbar = () => {
  resetProgressbar();
  percentTime = 0;
  isPause = false;
  tick = setInterval(interval, 30);
}

const interval = () => {
  if (isPause === false) {
    percentTime += 1 / (time + 0.1);
    $bar.css({
      width: percentTime + "%",
      maxWidth: percentTime + "%"
    });
    if (percentTime >= 100) {
      $slides.slick('slickNext');
      startProgressbar();
    }
  }
}

const resetProgressbar = () => {
  $bar.css({
    width: 0 + '%',
    maxWidth: 0 + '%'
  });
  clearTimeout(tick);
}

if ($bar.length) {
  startProgressbar();
}

$(window)
  .on('load resize', function () {
    clearTimeout(timeout)

    timeout = setTimeout(function () {
      $thumbs.slick('reinit');
    }, 300)
  })
